import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { useOutsideClick } from "../../hooks/useOutsideClick.js";
import teamList from "../../assets/data/teamList.json"
import { setIsVisualizePageVisible } from "../../redux/createImageSlice.js";
import { IoLogOutOutline } from "react-icons/io5";
import { setPrompt } from "../../redux/promptSlice.js";
import { setClearImageDiscription } from "../../redux/uploadImageSlice.js";
import { setRecommendedFontListFromMd5 } from "../../redux/fontListSlice.js";
import { setIsTipsForBestResults } from "../../redux/onBoardingSlice.js";
import TipsForBestResultLogo from '../../assets/images/brightTipsLogo.svg'
import { CloseIconSvg } from "../ui/Svgs.jsx";
import disclaimers from '../../assets/images/dangerSvg.svg'
import { setIsOpenTermsAndConditionsModal } from "../../redux/imageModalSlice.js";
import { setTermsAndConditions } from "../../redux/authSlice.js";
import { Tooltip as ReactTooltip } from "react-tooltip";


const Tooltip = ({ id, place, content, hideOnLargeScreen }) => (
  <ReactTooltip
    id={id}
    place={place}
    content={content}
    style={{ backgroundColor: '#1E242C', borderRadius: '8px', fontSize: '13px', lineHeight: '16px', zIndex: '9999' }}
    className={hideOnLargeScreen ? 'lg:hidden' : ''}
  />
);


const Navbar = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth0();
  const username = user.name;
  const profilePic = user.picture;
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const disclaimerRef = useRef(null);

  const [profileDropdown, setProfileDropdown] = useState(false);

  useOutsideClick(dropdownRef, () => setProfileDropdown(false));

  const { onBoardingSteps } = useSelector((state) => state.onBoarding);
  const { isImageLoading } = useSelector((state) => state.createImage);
  const { isVisualizePageVisible } = useSelector((state) => state.createImage);


  const [openDisclaimer, setOpenDisclaimer] = useState(false);


  const getNavLinkClass = (isActive) => {
    return isActive
      ? " mx-[20px] text-decoration-none text-pink-primary hover:text-pink-primary font-[500] border-b-2 border-pink-primary "
      : " mx-[20px] text-decoration-none text-[#576579] font-[400] hover:text-pink-primary ";
  };

  const nameHandler = (username) => {
    const name = username.split(" ");
    return name[0][0];
  };

  const onclickMonotypeIcon = () => {
    if (isImageLoading) return;
    dispatch(setIsVisualizePageVisible(true));
    dispatch(setPrompt(""));
    navigate("/generate-image");
    dispatch(setClearImageDiscription())
    dispatch(setRecommendedFontListFromMd5([]))
  };

  const handleTipsForBestResultOpen = () => {
    if (window.location.pathname === '/admin/analytics' || window.location.pathname === '/admin/dashboard') return
    dispatch(setIsTipsForBestResults(true));
  }


  useEffect(() => {
    function handleClickOutside(event) {
      if (disclaimerRef.current && !disclaimerRef.current.contains(event.target)) {
        setOpenDisclaimer(false);
      }
    }

    if (openDisclaimer) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDisclaimer]);

  const termsAndConditions = () => {
    setOpenDisclaimer(false)
    if (isVisualizePageVisible && window.location.pathname === '/generate-image') {
      dispatch(setTermsAndConditions(true))
    } else {
      dispatch(setIsOpenTermsAndConditionsModal(true))
    }
  }


  return (
    <>
      <nav className='w-full h-[80px] relative  top-0 bg-white shadow-navbar-botton '>
        <div className='h-full flex justify-between items-center pt-[24px] px-[40px]'>
          <div className='h-[56px] flex items-center justify-center'>
            <div className='relative flex items-center gap-[4px] leading-[29.4px] '>
              {/* Monotype. Portr<span className="text-pink-primary italic">ai</span>t */}
              {/* <img src={MonotypeLogo} alt="" /> */}
              {/* <img src={Portrait} alt="" /> */}
              <h1 onClick={onclickMonotypeIcon} className=" cursor-pointer">Portrait</h1>
              <div className='absolute -top-[12px] -right-[55px] h-[20px] w-[52px] py-[2px] px-[8px] text-[11px] bg-[#FBF2F4] text-[#D52377] rounded-[4px] flexCenter font-helveticaText-Medium cursor-default'>Alpha</div>
            </div>
          </div>
          <div className='h-[56px] pt-[16px] flex tracking-[0.5px]'>
            <NavLink to="/generate-image" className={({ isActive }) => getNavLinkClass(isActive)} >Create</NavLink>
            <NavLink to="/your-past-creations" className={({ isActive }) => getNavLinkClass(isActive)}>Past Creations</NavLink>
            {teamList.includes(user.email) &&
              <>
                <NavLink to="/admin/dashboard" className={({ isActive }) => getNavLinkClass(isActive)}>Dashboard</NavLink>
                <NavLink to="/admin/analytics" className={({ isActive }) => getNavLinkClass(isActive)}>Analytics</NavLink>
              </>
            }

          </div>
          <div className='h-[56px] flex items-center justify-center gap-[16px]'>
            <div className="h-[40px] flex items-center justify-center gap-[4px]">
              <button onClick={(e) => {
                e.stopPropagation();
                setOpenDisclaimer((prev) => !prev);
              }} className={`px-[16px] py-[12px] rounded-[8px] flex items-center justify-center gap-[8px] cursor-pointer hover:bg-[#F3F4F6] ${openDisclaimer ? 'bg-[#F3F4F6]' : ''}`}>
                <img data-tooltip-id="disclaimer" src={disclaimers} alt="" className="h-[16px] w-[16px]" />
                <p className='hidden lg:flex text-[13px] leading-[16px] font-helveticaText-Medium'>Disclaimer</p>
                <Tooltip id={`disclaimer`} place="bottom" content="Disclaimer" hideOnLargeScreen={true} />
              </button>
              {openDisclaimer &&
                <div ref={disclaimerRef} className="w-[450px] border-t border-[0.2px] bg-white p-[40px] absolute z-50 top-[78px] right-[140px] lg:right-[270px] shadow-xl rounded-lg flex flex-col gap-[24px] ">
                  <CloseIconSvg onClick={() => setOpenDisclaimer(false)} className="absolute top-4 right-4 cursor-pointer" />
                  <h2 className="text-[24px] leading-[32px] text-[#1E242C] font-helveticaText-Medium">Disclaimer</h2>
                  <div className="flex flex-col gap-[16px]">
                    <p className='text-[13px] text-[#667488]'>AI-generated visualizations aim to closely replicate original fonts; however, slight variations may occur.</p>
                    <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify' >
                      Portrait is designed to inspire users by showing how fonts look in visual settings. The main text reflects the chosen font, while smaller text may appear unreadable.
                      Please refer to our<a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>
                        &nbsp; terms and conditions
                      </a> for more details on image usage guidelines.
                    </h5>
                  </div>
                  <button onClick={() => setOpenDisclaimer(false)} className="w-fit px-[16px] py-[12px] rounded-[8px] font-[500] tracking-[0.02em] bg-[#1A73E8] text-white">I Understand</button>
                </div>
              }

              <button
                onClick={handleTipsForBestResultOpen}
                className={`flex items-center gap-[4px] px-[16px] py-[12px] rounded-[8px] cursor-pointer ${onBoardingSteps === 6 ? 'z-[98] bg-white h-full px-[16px]' : ''} hover:bg-[#F3F4F6]`}
              >
                <img data-tooltip-id="tips-for-best-result" src={TipsForBestResultLogo} alt="" className="h-[18px] w-[18px]" />
                <h2 className="hidden lg:flex font-helveticaText-Bold text-[13px] ">Tips for best results</h2>
                <Tooltip id={`tips-for-best-result`} place="bottom" content="Tips for best results" hideOnLargeScreen={true} />
              </button>
            </div>
            <div className="" ref={dropdownRef}>

              {profilePic ? (
                <img
                  src={profilePic}
                  alt=""
                  className="m-0 h-8 w-8 bg-[#76BA93] flex items-center justify-center rounded-full text-white text-[20px] cursor-pointer select-none "
                  onClick={() => setProfileDropdown((prev) => !prev)}
                />
              ) : (
                <p
                  className="m-0 h-8 w-8 bg-[#76BA93] flex items-center justify-center rounded-full text-white text-[20px] cursor-pointer select-none "
                  onClick={() => setProfileDropdown((prev) => !prev)}
                >
                  {nameHandler(username)}
                </p>
              )}
              {profileDropdown && (
                <div className="bg-white p-[12px] absolute z-50 top-[80px] right-10 border-2 border-[#dee2e6] rounded-lg flex flex-col gap-2 ">
                  <div
                    className=' w-full  flex flex-col justify-center  gap-[12px] font-helvetica-text rounded-lg '>
                    <span className='text-[#576579] text-[15px]'>
                      {user.name.length > 15 ? `${user.name.substring(0, 15)}...` : user.name}
                    </span>
                    <span className='text-[#576579] text-[15px]'>
                      {user.email.length > 30 ? `${user.name.substring(0, 30)}...` : user.email}
                    </span>
                    <div onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })} className='flex gap-2 cursor-pointer text-[16px]'>
                      <IoLogOutOutline size={25} className='rotate-180 text-red-400' />
                      Logout
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>



    </>
  );
};

export default Navbar;